import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Oromo Gadaa-UK</h3>
            <p>Preserving our heritage, building our future together in the United Kingdom.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact Info</h3>
            <p>127 Dean Road<br/>Bolton BL3 5AG<br/>Greater Manchester<br/>United Kingdom</p>
            <p>Email: info@gadaauk.com</p>
            <p>Phone: +44 7493193493</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Oromo Gadaa-UK. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
